import { create } from 'zustand';

import { DatasetsFileType, DatasetsInfo } from '@mygpt/app';

interface DatasetStoreState {
  count: DatasetsFileType;
  resetCount: () => void;
  init: (count: DatasetsFileType) => void;
  setCount: (type: keyof DatasetsFileType | 'web-connector' | 'lark' | 'gbase_project', count: number) => void;

  datasetInfo: DatasetsInfo | null;
  setDatasetInfo: (datasetInfo: DatasetsInfo) => void;

  isCloning: boolean;
  setIsCloning: (isCloning: boolean) => void;

  cloningTipOpened: boolean;
  setCloningTipOpened: (cloningTipOpened: boolean) => void;

  cloneTarget: DatasetsInfo | null;
  setCloneTarget: (cloneTarget: DatasetsInfo | null) => void;

  advancedTrainModelList: { value: string; label: string; enable: boolean }[];
  setAdvancedTrainModelList: (advancedTrainModelList: { value: string; label: string; enable: boolean }[]) => void;
}

export const useDatasetStore = create<DatasetStoreState>((set, get) => ({
  count: {
    api: 0,
    faq: 0,
    file: 0,
    gitbook: 0,
    property: 0,
    sitemap: 0,
    website: 0,
    integration: {
      lark: 0,
      web_connector: 0,
      gbase_project: 0,
    },
  },
  resetCount: () =>
    set({ count: { ...get().count, ...Object.keys(get().count).reduce((acc, cur) => ({ ...acc, [cur]: 0 }), {}) } }),
  init: (count: DatasetsFileType) => set({ count }),
  setCount: (type: keyof DatasetsFileType | 'web-connector' | 'lark' | 'gbase_project', count: number) => {
    const currentCount = get().count;

    if (type === 'web-connector') {
      // 特殊处理 web-connector，更新到 integration.web_connector
      set({
        count: {
          ...currentCount,
          integration: {
            ...currentCount.integration,
            web_connector: count,
          },
        },
      });
    } else if (type === 'lark') {
      // 特殊处理 lark，更新到 integration.lark
      set({
        count: {
          ...currentCount,
          integration: {
            ...currentCount.integration,
            lark: count,
          },
        },
      });
    } else if (type === 'gbase_project') {
      // 特殊处理 gbase_project，更新到 integration.gbase_project
      set({
        count: {
          ...currentCount,
          integration: {
            ...currentCount.integration,
            gbase_project: count,
          },
        },
      });
    } else {
      // 普通的顶级字段更新
      set({ count: { ...currentCount, [type]: count } });
    }
  },

  datasetInfo: null,
  setDatasetInfo: (datasetInfo) => set({ datasetInfo }),

  isCloning: false,
  setIsCloning: (isCloning) => set({ isCloning }),

  cloningTipOpened: false,
  setCloningTipOpened: (cloningTipOpened) => set({ cloningTipOpened }),

  // 用于判断cloneModal的开启状态，并存储复制目标信息
  cloneTarget: null,
  setCloneTarget: (cloneTarget) => set({ cloneTarget }),

  advancedTrainModelList: [],
  setAdvancedTrainModelList: (advancedTrainModelList) => set({ advancedTrainModelList }),
}));
